import React from 'react';

import classNames from 'classnames';
import Icon from 'components/icons';
import { ITEM_TYPE } from 'modules/content/constants';
import PropTypes from 'prop-types';

import './DraggingCard.scss';

const DraggingCard = ({ label, provided, type }) => {
  const className = classNames('dragging-card', {
    '-module': type === ITEM_TYPE.MODULE,
    '-page': type === ITEM_TYPE.PAGE
  });

  return (
    <div
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
      className={className}
      data-test="dragging-card"
    >
      <Icon
        prefix="fal"
        iconName="grip-lines"
        className="icon"
        data-test="icon"
      />
      <p className="label" data-test="label">
        {label}
      </p>
    </div>
  );
};

DraggingCard.propTypes = {
  label: PropTypes.string,
  provided: PropTypes.object,
  type: PropTypes.string
};

export default DraggingCard;
